import { SeekDisplay } from ".";
import Section from "./Section";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBible, faClock } from "@fortawesome/free-solid-svg-icons";
import { useRef } from "react";
import { useDimensions } from "../../hooks/useDimensions";
import { interpolateByRange } from "../../utils/interpolator";
import { useSeekBar } from "../../contexts/SeekBar";
import { useRoot } from "../../contexts/Root";
import { useCrossHair } from "../../contexts/CrossHair";
import { useLayout } from "../../contexts/Layout";

export const CrossHairDisplay = () => {
  const ref = useRef(null);
  const {
    theme: { foreground, fadedForeground },
  } = useRoot();
  const { isMobile } = useLayout();

  const { width: seekBarWidth } = useSeekBar();
  const { show, offset, stringifiedTime, isOnMarker, markerLabel } =
    useCrossHair();

  const { width } = useDimensions(show, ref);

  const interpolatedOffset = interpolateByRange(
    0,
    offset - width / 2,
    seekBarWidth - width
  );

  return (
    <SeekDisplay
      ref={ref}
      show={show && !isMobile}
      offset={interpolatedOffset}
      expand={isOnMarker}
    >
      <Section
        color={foreground}
        text={stringifiedTime}
        icon={<FontAwesomeIcon icon={faClock} />}
      />
      {markerLabel !== undefined && (
        <Section
          color={fadedForeground}
          text={markerLabel}
          icon={<FontAwesomeIcon icon={faBible} />}
        />
      )}
    </SeekDisplay>
  );
};
